import { render, staticRenderFns } from "./updateTemplateForm.vue?vue&type=template&id=2e224079&scoped=true"
import script from "./updateTemplateForm.vue?vue&type=script&lang=js"
export * from "./updateTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e224079",
  null
  
)

export default component.exports